import * as React from "react";
import { kebabCase } from "lodash";
import { Helmet } from "react-helmet";
import { Link, graphql } from "gatsby";
import Layout from "../../components/Layout";

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout>
    <section className="section-tags">
          <div
            className="full-width-image-container margin-top-0"
            style={{
              backgroundImage: `url('/img/omt-blog-background.png')`,
            }}
          >
            <h1
              className="has-text-weight-bold is-size-1"
              style={{
                boxShadow: "0.5rem 0 0 #f40, -0.5rem 0 0 #f40",
                backgroundColor: "#f40",
                color: "white",
                padding: "1rem",
              }}
            >
              Explore Articles By Category
            </h1>
          </div>
        </section>
    <section className="section tags-section">
      <Helmet title={`Tags | ${title}`} />
      <div className="container content">
        <div className="columns">
          <div
            className="column is-10 is-offset-1"
            style={{ marginBottom: "7rem" }}
          >                               
            <h1 className="title is-size-2 is-bold-light">Explore Tags</h1>
            <hr></hr>
            <ul className="taglist">
              {group.map((tag) => (
                <li key={tag.fieldValue}>
                  <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                    <span className="tag-name">{tag.fieldValue}</span>
                    <span className="tag-count">{tag.totalCount}</span>
                  </Link>
                </li>
              ))}
            </ul>
            <hr></hr>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default TagsPage;

export const tagPageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
